import { render } from "./PhraseScheduleBox.vue?vue&type=template&id=cb8a79fa&scoped=true"
import script from "./PhraseScheduleBox.vue?vue&type=script&lang=js"
export * from "./PhraseScheduleBox.vue?vue&type=script&lang=js"

import "./PhraseScheduleBox.vue?vue&type=style&index=0&id=cb8a79fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb8a79fa"]])

export default __exports__